// extracted by mini-css-extract-plugin
export const figure = "our-impact-module--figure--YVAfK";
export const icon = "our-impact-module--icon--3pm43";
export const contents = "our-impact-module--contents--3rv4P";
export const ourImpactSection = "our-impact-module--ourImpactSection--gsQvp";